import { render, staticRenderFns } from "./student-details.vue?vue&type=template&id=738e629e&scoped=true&"
import script from "./student-details.vue?vue&type=script&lang=js&"
export * from "./student-details.vue?vue&type=script&lang=js&"
import style0 from "./student-details.vue?vue&type=style&index=0&id=738e629e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738e629e",
  null
  
)

component.options.__file = "student-details.vue"
export default component.exports